import { useServicesContext } from "@modules/core/services/services.context"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { useInfiniteQuery } from "@tanstack/react-query"
import { useMemo } from "react"

export const useProgramBundleSubscribers = (programBundleId: string, searchTerm?: string) => {
  const { programBundleSubscriberApi } = useServicesContext()

  const { data, isLoading, refetch, isFetching, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: ["programBundleSubscribers", programBundleId, searchTerm?.toLocaleLowerCase()],
    queryFn: async ({ pageParam }) => {
      return await programBundleSubscriberApi.searchProgramBundleSubscribers(
        programBundleId,
        pageParam,
        20,
        searchTerm?.toLocaleLowerCase(),
      )
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (lastPage.page >= lastPage.totalPages - 1) {
        return undefined
      }
      return lastPage.page + 1
    },
  })

  const subscriberList = useMemo(
    () =>
      data?.pages
        .flatMap((page) => page.content)
        .map((content) => ProgramBundleSubscriberEntity.fromItemDto(content)) ?? [],
    [data],
  )

  return {
    data: {
      ...data,
      content: subscriberList,
      totalSize: data?.pages[0]?.totalSize ?? 0,
    },
    isLoading,
    refetch,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  }
}
